import { render, staticRenderFns } from "./GradingItem.vue?vue&type=template&id=17667f44&scoped=true"
import script from "./GradingItem.vue?vue&type=script&lang=js"
export * from "./GradingItem.vue?vue&type=script&lang=js"
import style0 from "./GradingItem.vue?vue&type=style&index=0&id=17667f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17667f44",
  null
  
)

export default component.exports